import {
  POPULATE_BUS_LIST,
  FILTER_BUS_LIST,
  RESET_FILTER
} from "../actions/action-types.js";
import { FILTERS } from "../utils/constants";
import lodashCloneDeep from "lodash/cloneDeep";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
  buses: [],
  noFilterbuses: [],
  filters: {
    [FILTERS.SORT]: [],
    [FILTERS.FILTER_ARRIVAL_TIME]: "",
    [FILTERS.FILTER_DEPART_TIME]: "",
    [FILTERS.FILTER_BOARDING]: [],
    [FILTERS.FILTER_DROPPING]: [],
    [FILTERS.FILTER_BUS_TYPE]: []
  }
};

const resetFilter = newState => {
  newState.filters = {
    [FILTERS.SORT]: [],
    [FILTERS.FILTER_ARRIVAL_TIME]: "",
    [FILTERS.FILTER_DEPART_TIME]: "",
    [FILTERS.FILTER_BOARDING]: [],
    [FILTERS.FILTER_DROPPING]: [],
    [FILTERS.FILTER_BUS_TYPE]: []
  };
  newState.buses = newState.noFilterbuses;
};

const busListingReducer = (state = initialState, action) => {
  let newState = null;
  switch (action.type) {
    case POPULATE_BUS_LIST:
      newState = lodashCloneDeep(state);
      newState.buses = action.payload.buses;
      newState.noFilterbuses = action.payload.buses;
      return newState;
    case FILTER_BUS_LIST:
      newState = lodashCloneDeep(state);
      newState.buses = filterBus(action.payload, newState);
      return newState;
    case RESET_FILTER:
      newState = lodashCloneDeep(state);
      resetFilter(newState);
      return newState;
    default:
      return state;
  }
};

const sortFare = (type, bus) => {
  return bus.sort((a, b) => {
    if (b.isRTC === false) return false;
    if (b.isRTC === true) {
      return b.buses.sort((a, b) => {
        return (
          parseInt(a[type].TotalFare.replace(":", "")) -
          parseInt(b[type].TotalFare.replace(":", ""))
        );
      });
    }

    return (
      parseInt(a[type].TotalFare.replace(":", "")) -
      parseInt(b[type].TotalFare.replace(":", ""))
    );
  });
};

const sortBus = (type, bus) => {
  return bus.sort((a, b) => {
    if (b.isRTC === false) return false;
    if (b.isRTC === true) {
      return b.buses.sort((a, b) => {
        return (
          parseInt(a[type].replace(":", "")) -
          parseInt(b[type].replace(":", ""))
        );
      });
    }

    return (
      parseInt(a[type].replace(":", "")) - parseInt(b[type].replace(":", ""))
    );
  });
};

const busType = (type, bus) => {
  return bus.filter(b => {
    if (b.isAPSRTC === true || b.isAPSRTC === false) return false;
    return b.BusType[type];
  });
};

const boardingndroppingFilter = (type, value, bus) => {
  type === FILTERS.FILTER_BOARDING
    ? (type = "DeparturePoints")
    : (type = "ArrivalPoints");
  if (!value.length > 0) return bus;

  return bus.filter(b => {
    if (b.isAPSRTC === true || b.isAPSRTC === false) return false;
    return b[type].some(d => value.includes(d.Name));
  });
};

const timeFilter = (type, value, bus) => {
  return bus.filter(b => {
    if (b.isAPSRTC === true || b.isAPSRTC === false) return false;
    let time = "";

    type === FILTERS.FILTER_DEPART_TIME
      ? (time = parseInt(b.DepartureTime.replace(":", "")))
      : (time = parseInt(b.ArrivalTime.replace(":", "")));

    switch (value) {
      case FILTERS.BEFORE6AM:
        return time <= 600;
      case FILTERS.BETWEEN_6AM_12PM:
        return 600 <= time && time <= 1200;
      case FILTERS.BETWEEN_12PM_6PM:
        return 1200 <= time && time <= 1800;
      case FILTERS.AFTER6PM:
        return time >= 1800;
      default:
        return true;
    }
  });
};

//filters for APSRTC buses
const APSRTC = (type, bus, filtertype, fvalue) => {
  var seatCount = 0;
  var Abus;
  if (filtertype === "busType") Abus = busType(type, bus.buses);
  if (filtertype === "timeFilter") Abus = timeFilter(type, fvalue, bus.buses);
  if (filtertype === "boardingndroppingFilter")
    Abus = boardingndroppingFilter(type, fvalue, bus.buses);

  if (Abus.length > 0) {
    var startsAt = Abus[0].DepartureTime;
    Abus.forEach(b => {
      seatCount = seatCount + b.AvailableSeats;

      if (
        parseInt(startsAt.replace(":", ""), 10) >
        parseInt(b.DepartureTime.replace(":", ""), 10)
      ) {
        startsAt = b.DepartureTime;
      }
    });
    bus.buses = Abus;
    bus.summary.busCount = Abus.length;
    bus.summary.seatCount = seatCount;
  } else {
    bus.buses = [];
    bus.isRTC = false;
    bus.isAPSRTC = false;
  }
  return bus;
};

const filterBus = (obj, newState) => {
  // let bus = [...newState.noFilterbuses];
  let bus = cloneDeep(newState.noFilterbuses);
  var busRTC, Rbus;
  if (
    obj.type === FILTERS.FILTER_ARRIVAL_TIME ||
    obj.type === FILTERS.FILTER_DEPART_TIME
  ) {
    newState.filters[obj.type] === obj.data
      ? (newState.filters[obj.type] = "")
      : (newState.filters[obj.type] = obj.data);
  } else if (
    obj.type === FILTERS.FILTER_BOARDING ||
    obj.type === FILTERS.FILTER_DROPPING
  ) {
    newState.filters[obj.type] = obj.data;
  } else if (obj.type === FILTERS.SORT) {
    newState.filters[obj.type] = obj.data;
  } else {
    newState.filters[obj.type].includes(obj.data)
      ? newState.filters[obj.type].pop(obj.data)
      : newState.filters[obj.type].push(obj.data);
  }

  let f = newState.filters;
  Object.keys(f).forEach(type => {
    //sorting
    if (type === FILTERS.SORT) {
      if (f[type] === FILTERS.SORT_DEPARTURE) {
        bus = sortBus("DepartureTime", bus);
      } else if (f[type] === FILTERS.SORT_DURATION) {
        bus = sortBus("Duration", bus);
      } else if (f[type] === FILTERS.SORT_FARE) {
        bus = sortFare("Fare", bus);
      }
    }

    //bus category
    else if (type === FILTERS.FILTER_BUS_TYPE) {
      if (f[type].includes(FILTERS.SLEEPER)) {
        if (bus[0].isAPSRTC === true) {
          busRTC = APSRTC("Sleeper", bus[0], "busType");
        } else {
          busRTC = bus[0];
        }

        Rbus = busType("Sleeper", bus);
        bus = [busRTC, ...Rbus];
      }

      if (f[type].includes(FILTERS.SEMI_SLEEPER)) {
        if (bus[0].isAPSRTC === true) {
          busRTC = APSRTC("SemiSleeper", bus[0], "busType");
        } else {
          busRTC = bus[0];
        }
        Rbus = busType("SemiSleeper", bus);
        bus = [busRTC, ...Rbus];
      }

      if (f[type].includes(FILTERS.AC)) {
        if (bus[0].isAPSRTC === true) {
          busRTC = APSRTC("AC", bus[0], "busType");
        } else {
          busRTC = bus[0];
        }
        Rbus = busType("AC", bus);
        bus = [busRTC, ...Rbus];
      }

      if (f[type].includes(FILTERS.MULTI_AXLE)) {
        if (bus[0].isAPSRTC === true) {
          busRTC = APSRTC("MultiAxle", bus[0], "busType");
        } else {
          busRTC = bus[0];
        }
        Rbus = busType("MultiAxle", bus);
        bus = [busRTC, ...Rbus];
      }
    }

    // timimgs
    else if (
      type === FILTERS.FILTER_DEPART_TIME ||
      type === FILTERS.FILTER_ARRIVAL_TIME
    ) {
      if (f[type] !== "") {
        if (bus[0].isAPSRTC === true) {
          busRTC = APSRTC(type, bus[0], "timeFilter", f[type]);
        } else {
          busRTC = bus[0];
        }
        Rbus = timeFilter(type, f[type], bus);
        bus = [busRTC, ...Rbus];
      }
    }

    //boarding n dropping points
    else if (
      type === FILTERS.FILTER_BOARDING ||
      type === FILTERS.FILTER_DROPPING
    ) {
      if (f[type].length > 0) {
        if (bus[0].isAPSRTC === true) {
          busRTC = APSRTC(type, bus[0], "boardingndroppingFilter", f[type]);
        } else {
          busRTC = bus[0];
        }
        Rbus = boardingndroppingFilter(type, f[type], bus);
        bus = [busRTC, ...Rbus];
      }
    }
  });
  console.log(bus);
  return bus;
};

export default busListingReducer;
